// extracted by mini-css-extract-plugin
export default {"container":"Tabs_container__1j3xl","wrapperBtn":"Tabs_wrapperBtn__mMpaq","btn":"Tabs_btn__qE8cz","list":"Tabs_list__uYvui","item":"Tabs_item__QdwVK"};